const PromotionType = {
    PRODUCT: 'product',
    COUPON: 'coupon',
};
var OrderBy;
(function (OrderBy) {
    OrderBy["ASC"] = "ASC";
    OrderBy["DESC"] = "DESC";
})(OrderBy || (OrderBy = {}));

export { OrderBy, PromotionType };
